import moment from 'moment'
import 'moment/locale/zh-cn'
import store from '../store'

moment.locale('zh-cn')

/**
 * 去除字符串两端空格
 * @param value string
 */
export function trim(value) {
  return value.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 是否为非空字符串
 */
export function nonEmptyString(value) {
  return (
    Object.prototype.toString.call(value) === '[object String]' && value !== ''
  )
}

export const toValue = (value) => value || ''

/**
 * 遍历部门
 * type 1-默认，2-显示部门人数
 */
export function traverseDpTree(
  node,
  type = 1,
  is_disable = false,
  disabledIds = [], //禁用的部门
  isDisabledChild = true // 下级部门也禁用
) {
  for (let i of node) {
    switch (type) {
      case 1:
        i.title = i.department_name
        break
      case 2:
        i.title = `${i.department_name}(${i.num}人)`
        break
    }

    if (is_disable) {
      if (disabledIds) {
        if (
          disabledIds.indexOf(i.department_id + '') > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all')
        ) {
          i.disabled = true
        } else {
          i.disabled = false
        }
      } else {
        i.disabled = i.is_disabled === 1
      }
    }
    i.slots = { icon: 'folder' }
    i.key = i.department_id + ''
    i.value = i.department_id + ''
    if (i.department_id === 1) {
      i.slots = { icon: 'cluster' }
    }
    if (i.child && i.child.length > 0) {
      i.children = i.child

      if (
        disabledIds &&
        (disabledIds.indexOf(i.department_id + '') > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all')) &&
        isDisabledChild
      ) {
        traverseDpTree(i.children, type, is_disable, ['all'], isDisabledChild)
      } else {
        traverseDpTree(
          i.children,
          type,
          is_disable,
          disabledIds,
          isDisabledChild
        )
      }
    }
  }
}

/**
 * 遍历部门 2 传title专用
 * type 1-默认，2-显示部门人数
 */
export function traverseDpTree2(
  node,
  type = 1,
  is_disable = false,
  disabledIds
) {
  for (let i of node) {
    switch (type) {
      case 1:
        i.title = i.department_name
        break
      case 2:
        i.title = `${i.department_name}(${i.num}人)`
        break
    }

    if (is_disable) {
      if (disabledIds) {
        if (
          disabledIds.indexOf(i.department_id) > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all')
        ) {
          i.disabled = true
        }
      } else {
        i.disabled = i.is_disabled === 1
      }
    }
    i.slots = { icon: 'folder' }
    i.key = i.department_id + ''
    i.value = i.department_id + '-' + i.department_name
    if (i.department_id === 1) {
      i.slots = { icon: 'cluster' }
    }
    if (i.child && i.child.length > 0) {
      i.children = i.child

      if (
        disabledIds &&
        (disabledIds.indexOf(i.department_id) > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all'))
      ) {
        traverseDpTree2(i.children, type, is_disable, ['all'])
      } else {
        traverseDpTree2(i.children, type, is_disable, disabledIds)
      }
    }
  }
}

/**
 * 遍历部门
 * type 1-默认，2-显示部门人数
 */
export function traverseDpTreeTwo(
  node,
  type = 1,
  is_disable = false,
  disabledIds = [], //禁用的部门
  isDisabledChild = true // 下级部门也禁用
) {
  for (let i of node) {
    switch (type) {
      case 1:
        i.title = i.department_name
        break
      case 2:
        i.title = `${i.department_name}(${i.num}人)`
        break
    }

    if (is_disable) {
      if (disabledIds) {
        if (
          disabledIds.indexOf(i.department_id + '') > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all')
        ) {
          i.disabled = true
        } else {
          i.disabled = false
        }
      } else {
        i.disabled = i.is_disabled === 1
      }
    }
    i.slots = { icon: 'folder' }
    i.key = i.department_id + ''
    i.value = i.department_id + ''
    if (i.department_id === 1) {
      i.slots = { icon: 'cluster' }
    }
    if (i.child && i.child.length > 0) {
      i.children = i.child

      if (
        disabledIds &&
        (disabledIds.indexOf(i.department_id + '') > -1 ||
          (disabledIds.length > 0 && disabledIds[0] === 'all')) &&
        isDisabledChild
      ) {
        traverseDpTree(i.children, type, is_disable, ['all'], isDisabledChild)
      } else {
        traverseDpTree(
          i.children,
          type,
          is_disable,
          disabledIds,
          isDisabledChild
        )
      }
    }
  }
}

/**
 * 遍历地区，树形
 */
export function regionTreeForScreening(node) {
  for (let i of node) {
    i.title = i.region_name
    i.key = i.region_id
    i.value = i.region_name + '-' + i.region_id + '-' + i.level
    if (i.child) {
      i.children = i.child
      regionTreeForScreening(i.children)
    }
  }
}

/**
 * 遍历产品，树形
 */
export function goodsNameTreeForScreening(node) {
  for (let i of node) {
    i.title = i.name
    i.pId = 0
    i.key = i.name
    i.value = i.name
    i.children = []
    if (i.child) {
      i.children = i.child
      regionTreeForScreening(i.children)
    }
  }
}

/**
 * 遍历产品，树形
 */
export function goodsTreeForScreening(node, pId) {
  for (let i of node) {
    i.title = i.name + ' ' + i.spec
    i.key = i.goods_id
    i.value = i.title
    i.isLeaf = true
    i.selfGoodsId = (i.goods_id + '').split(',')
    // i.pId = pId;
    // if (i.child) {
    //   i.children = i.child;
    //   regionTreeForScreening(i.children);
    // }
  }
}

/**
 * 遍历产品分类
 * type 1-默认，2-显示分类下产品数
 */
export function traverseGoodsCategoryTree(node, type = 1) {
  for (let i of node) {
    switch (type) {
      case 1:
        i.title = i.name
        break
      case 2:
        i.title = `${i.name}(${i.count})`
        break
    }
    i.key = i.categories_id + ''
    i.value = i.categories_id + ''
    if (i.child && i.child.length > 0) {
      i.children = i.child
      traverseGoodsCategoryTree(i.children, type)
    }
  }
}

/**
 * date format
 */
export function dateFormat(value, format = 'YYYY/MM/DD') {
  if (nonEmptyString(value)) {
    return moment(value, format)
  } else {
    return null
  }
}

/**
 * undefined 转 空字符串
 */
export function noneToEmptyStr(value) {
  if (
    value !== 0 &&
    (!value || typeof value == 'undefined' || value === 'undefined')
  ) {
    return ''
  } else {
    return value
  }
}

/**
 * 用于筛选的产品列表,添加全部选项
 */
export function regionForScreening(regionList) {
  for (let item of regionList) {
    if (item.child && item.child.length > 0) {
      let total = {
        // region_id: item.region_id,
        region_id: '',
        region_name: '全部',
        tel_code: '',
        parent_id: item.parent_id
      }
      item.child.unshift(total)
      regionForScreening(item.child)
    }
  }
}

/**
 * 数组a是否包含数组b
 */
export function isContained(a, b) {
  if (!(a instanceof Array) || !(b instanceof Array)) return false
  if (a.length < b.length) return false
  var aStr = a.toString()
  for (var i = 0, len = b.length; i < len; i++) {
    if (aStr.indexOf(b[i]) == -1) return false
  }
  return true
}

/**
 * title换行
 */
export function titleMultiLine(str, cosNum) {
  if (!str) {
    return ''
  }
  if (!cosNum) {
    cosNum = 30
  }
  let userAgent = window.navigator.userAgent
  if (/webkit/i.test(userAgent)) {
    return str
  } else {
    let ret = new RegExp('(.{' + cosNum + '})', 'g')
    return str.replace(ret, '$1' + '\n')
  }
}

export function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

/**
 * 生成唯一id
 */
export function getUuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  return (
    S4() +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    S4() +
    S4()
  )
}

/**
 * 遍历部门 去树形
 */
export function departmentTransfer(list) {
  let dpList = []
  traverse(list)

  function traverse(list) {
    for (let item of list) {
      dpList.push(item)
      if (item.child && item.child.length > 0) {
        traverse(item.child)
      }
    }
  }

  return dpList
}

/**
 * 用于筛选的产品列表,添加全部选项
 */
export function regionForScreening2(regionList, index, isAll = true) {
  index++
  for (let item of regionList) {
    if (item.title != '全部' && index < 4) {
      item.isLeaf = false
    }
    if (item.child && item.child.length == 0) {
      delete item.child
    }
    if (item.child && item.child.length > 0) {
      if (isAll) {
        let total = {
          value: '',
          title: '全部'
        }
        item.child.unshift(total)
      }

      regionForScreening2(item.child, index)
    }
  }
}

/**
 * 用于产品分类添加全部去除底层箭头
 */
export function regionForScreening4(regionList, index, isAll = true) {
  index++
  for (let item of regionList) {
    if (item.title != '全部' && index < 4) {
      // item.isLeaf = false
    }
    if (item.child && item.child.length == 0) {
      delete item.child
    }
    if (item.child && item.child.length > 0) {
      if (isAll) {
        let total = {
          value: '',
          title: '全部'
        }
        item.child.unshift(total)
      }

      regionForScreening4(item.child, index)
    }
  }
}

/**
 * 用于筛选的产品分类,懒加载产品
 */
export function traverseGoodsCategoryLoad(list) {
  for (let item of list) {
    if (item.children && item.children.length > 0) {
      item.isLeaf = false
      traverseGoodsCategoryLoad(item.children)
    } else if (item.has_goods && item.has_goods == 1) {
      item.isLeaf = false
      delete item.children
    } else {
      item.isLeaf = true
    }
  }
}

/**
 * 遍历产品分类
 * type 1-默认，2-显示分类下产品数  产品打标签
 */
export function traverseGoodsCategoryTreeTag(node, type = 1) {
  for (let i of node) {
    switch (type) {
      case 1:
        i.title = i.name
        break
      case 2:
        i.title = `${i.name}(${i.count})`
        break
    }
    i.key = i.categories_id + ''
    i.value = i.categories_id + '-' + JSON.stringify(i.goods_ids)
    if (i.child && i.child.length > 0) {
      i.children = i.child
      traverseGoodsCategoryTreeTag(i.children, type)
    }
  }
}

/**
 * 转千分位
 * @param num
 * @returns {string}
 */
export function moneyFormat(num) {
  let tag = (num || 0).toString().split('.')
  tag[0] = tag[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return tag.join('.')
}

/**
 * 还原千分位
 * @param money
 * @returns {*}
 */
export function money2Num(money) {
  return money.replace(/\$\s?|(,*)/g, '')
}

/**
 *获取父级id
 * disabledIds 被禁用的子id数组
 */
export function getFatherIds(node, disabledIds) {
  let fatherIds = []
  traverseFatherDpTree(node, disabledIds)

  function traverseFatherDpTree(node, disabledIds) {
    for (let i of node) {
      if (
        disabledIds.indexOf(i.department_id) > -1 ||
        disabledIds.indexOf(i.department_id + '') > -1
      ) {
        // fatherIds
        if (i.path) {
          i.path = i.path.replace('{', '').replace('}', '')
          let newIds = i.path.split(',')
          for (let item of newIds) {
            fatherIds.push(parseInt(item))
          }
        }
      }
      if (i.child && i.child.length > 0) {
        traverseFatherDpTree(i.child, disabledIds)
      }
    }
  }

  return fatherIds
}

/**
 *获取子级id
 * disabledIds 被禁用的子id数组
 */
export function getChildIds(node, disabledIds) {
  let childIds = []
  traverseChildDpTree(node, disabledIds)

  function getIds(list) {
    if (list && list.child && list.child.length > 0) {
      for (let jj of list.child) {
        childIds.push(jj.department_id)
        getIds(jj)
      }
    }
  }

  function traverseChildDpTree(node, disabledIds) {
    for (let i of node) {
      if (
        disabledIds.indexOf(i.department_id) > -1 ||
        disabledIds.indexOf(i.department_id + '') > -1
      ) {
        // childIds
        getIds(i)
      } else {
        traverseChildDpTree(i.child, disabledIds)
      }
    }
  }

  return childIds
}

/**
 * 用于筛选的产品列表,添加全部选项 3
 */
export function regionForScreening3(regionList, index, isAll = true) {
  index++
  for (let item of regionList) {
    if (item.title == '全部' || !item.child || item.child.length == 0) {
      item.isLeaf = true
    }
    if (item.child && item.child.length == 0) {
      delete item.child
    }
    if (item.child && item.child.length > 0) {
      if (isAll) {
        let total = {
          categories_id: '',
          name: '全部'
        }
        item.child.unshift(total)
      }

      regionForScreening3(item.child, index)
    }
  }
}

export function toFix2(value) {
  let value_label = parseFloat(value)
  value_label = Math.round(value_label * 100) / 100
  let label2 = value_label.toString()
  let pos_decimal = label2.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = label2.length
    label2 += '.'
  }
  while (label2.length <= pos_decimal + 2) {
    label2 += '0'
  }
  return Number(label2)
}

export function toFix1(value) {
  let value_label = parseFloat(value)
  value_label = Math.round(value_label * 10) / 10
  let label2 = value_label.toString()
  let pos_decimal = label2.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = label2.length
    label2 += '.'
  }
  while (label2.length <= pos_decimal + 1) {
    label2 += '0'
  }
  return label2
}

// export function getNewDepartmentList(arr) {
//   console.log(arr,'156')
//   let arr1 = [];
//   transve(arr);
//     function transve(arr){
//       for(let item of arr){
//         if(item.department_id!==87){
//           if(item.child&&item.child.length>0){
//             transve(item.child)
//           }
//         }else{
//           item.check = true
//           arr1.push(item)
//         }
//       }
//     }
//     console.log(arr1,'arr1')
//     return arr1
// }

/**
 * 处理项目报告
 */
export function disposeItemReport(list) {
  let templateList = store.state.templateAttrList
  let obj = {}
  for (let i = 0; i < list.length; i++) {
    let tempData = templateList.filter(
      (item) => item.value == list[i].template_type
    )[0]
    let titleTxt = tempData.parent + '-' + tempData.label
    if (obj.hasOwnProperty(titleTxt)) {
      obj[titleTxt].push(list[i])
    } else {
      obj[titleTxt] = []
      obj[titleTxt].push(list[i])
    }
  }
  return obj
}

/**
 * 用于筛选 省 市
 */
export function regionForScreeningProvinceCity(regionList) {
  if (regionList) {
    for (let item of regionList) {
      if (item.child && item.child.length > 0) {
        let total = {
          region_id: item.region_id,
          region_name: '全部',
          tel_code: '',
          parent_id: item.parent_id
        }
        item.child.unshift(total)
        if (item.level == 2) {
          delete item.child
        }
        regionForScreeningProvinceCity(item.child)
      }
    }
  }
}

//三级联动替换
export function threeReplace(options) {
  if (options && options.length > 0) {
    for (let item1 of options) {
      item1.label = item1.option_val
      item1.value = item1.client_custom_options_id
      if (item1.list && item1.list.length > 0) {
        threeReplace(item1.list)
        item1.children = item1.list
      }
    }
  }
}

//三级联动取上级id
export function getThreeId(options, id, arr) {
  if (options && options.length > 0 && id) {
    for (let item1 of options) {
      if (item1.client_custom_option_id == id) {
        arr.push(item1.client_custom_option_id)
        if (item1.pid) {
          getThreeId(options, item1.pid, arr)
        }
      }
    }
  }
  return arr
}

//数组去重
export function arrayFilter(data = [], val = 'id') {
  let hash = {}
  const arr = data.reduce((preVal, curVal) => {
    hash[curVal[val]] ? '' : (hash[curVal[val]] = true && preVal.push(curVal))
    return preVal
  }, [])
  return arr
}

/**
 * 添加全部选项
 */
export function addAllOptions(
  data = [],
  sonVal = 'child',
  label = 'region_name',
  value = 'region_id',
  pid = 'pid',
  valueText = '',
  valuePid = ''
) {
  data.unshift({
    [label]: '全部',
    [value]: valueText,
    [pid]: valuePid
  })
  for (let item of data) {
    if (item[sonVal] && item[sonVal].length > 0) {
      addAllOptions(
        item[sonVal],
        sonVal,
        label,
        value,
        pid,
        item[value],
        item[pid]
      )
    }
  }
}

//对查询关键字中的特殊字符进行编码
export function encodeSearchKey(key = '') {
  const encodeArr = [
    {
      code: '%',
      encode: '%25'
    },
    {
      code: '?',
      encode: '%3F'
    },
    {
      code: '#',
      encode: '%23'
    },
    {
      code: '&',
      encode: '%26'
    },
    {
      code: '=',
      encode: '%3D'
    }
  ]
  console.log(key, key)
  if (typeof key == 'string') {
    return key.replace(/[%?#&=]/g, ($, index, str) => {
      for (const k of encodeArr) {
        if (k.code === $) {
          return k.encode
        }
      }
    })
  } else {
    return key
  }
}

//用于过滤到省，市，区
export function replaceRegion(arr = [], str) {
  for (let item of arr) {
    if (parseInt(item.level) >= parseInt(str)) {
      delete item.child
      // item.child = []
    }
    if (item.child && item.child.length) {
      replaceRegion(item.child, str)
    }
  }
}

//根据region_id得到某一项
export function getRegionItem(arr = [], ids = [], itemArr = []) {
  for (let item of arr) {
    if (ids.map(String).indexOf(String(item.region_id)) > -1) {
      itemArr.push(item)
    }
    if (item.child && item.child.length) {
      getRegionItem(item.child, ids, itemArr)
    }
  }
  return itemArr
}

/**
 * 添加全部选项
 */
export function initComponents(columns) {
  return {
    header: {
      cell: initDrag(columns)
    }
  }
}

export function initDrag(columns) {
  return (h, props, children) => {
    const { key, ...restProps } = props
    const col = columns.find((col) => {
      const k = col.dataIndex || col.key
      return k === key
    })
    // if (col.children){
    //   col = getRenderCoL(key, columns);
    // }
    if (!col || !col.width) {
      return h('th', { ...restProps }, [...children])
    }
    const dragProps = {
      key: col.dataIndex || col.key,
      class: 'table-draggable-handle',
      attrs: {
        w: 10,
        x: col.width,
        z: 1,
        axis: 'x',
        draggable: true,
        resizable: false
      },
      on: {
        dragging: (x, y) => {
          col.width = Math.max(x, 1)
        }
      }
    }
    const drag = h('vue-draggable-resizable', { ...dragProps })
    return h('th', { ...restProps, class: 'resize-table-th' }, [
      ...children,
      drag
    ])
  }
}

/**
 * 防抖函数
 * @param {*} fn 执行函数
 * @param {*} wait 防抖时间
 * @returns 闭包函数
 */
export function debounce(fn, wait = 300) {
  var timer
  return function () {
    //----需要防抖的方法（fn）的参数----
    var args = arguments //fn方法对象（数组形式）
    var that = this
    //------------------
    clearTimeout(timer) //清除上次请求计时
    timer = setTimeout(() => {
      //计算请求时间，大于0.5s则发送请求
      fn.apply(that, args) //接受数组形式参数
    }, wait)
  }
}

/**
 * 节流函数
 * @param {*} fn 执行函数
 * @param {*} wait 防抖时间
 * @returns 闭包函数
 */
export function throttle(fn, wait = 100) {
  let timer
  return function () {
    if (timer != null) return
    let context = this
    let args = arguments
    fn.apply(context, args)
    timer = setTimeout(() => {
      timer = null
    }, wait)
  }
}

/**
 * 处理产品分类树形列表
 * @param {*} list
 */
export function replaceProductTreeCategories(list) {
  for (let item of list) {
    if (!item.goods_id) {
      item.goods_id = `-${item.categories_id}`
      item.nameSpec = item.name
    }
    if (item.child && item.child.length > 0) {
      replaceProductTreeCategories(item.child)
    } else if (item.goods_list && item.goods_list.length > 0) {
      item.child = item.goods_list.map((g) => {
        return {
          ...g,
          nameSpec: g.name + ' ' + g.spec
          // name: g.name + ' ' + g.spec,
        }
      })
    } else {
      delete item.child //删除没有子级的child 避免点击后数据右侧产生空白
    }
  }
}